import setToolkitLabels from "@insight/toolkit-react/lib/utils/setToolkitLabels";
import { getCurrentLocale, fetchLabels} from "@insight/toolkit-utils";

export default function getTranslations() {
  const locale = getCurrentLocale("insight_current_locale", "insight_locale");
  const isDebranded =
    window &&
    window.Insight &&
    window.Insight.b2bLoginInfo &&
    window.Insight.b2bLoginInfo.debrandSite;
  return fetchLabels({ labelFileName: "app-create-limited-account", app: 'app-create-account', isDebranded, locale, migrated: true }).then((labels) => {
    setToolkitLabels(labels)
  })
}
